module.exports = __webpack_public_path__ + "img/us_bg.1fa060fa.png";